import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { BillingFacade, PLANS_MAP } from '@app/shared/+state/billing';
import { Plan, PlanId, isNotSubscribed, isPendingSubscription } from '@app/shared/+state/billing/billing.models';
import { UpsellService } from '@app/shared/+state/shared/upsell.service';
import { SubscriptionData } from '@app/shared/interfaces';
import { take } from 'rxjs/operators';

export interface PlanCardSelectEvent {
  planId: PlanId;
  downgrade?: boolean;
  isCurrentPlan?: boolean;
  resume?: boolean;
  renew?: boolean;
}
@Component({
  standalone: false,
  selector: 'sbnb-plan-card',
  templateUrl: './plan-card.component.html',
  styleUrls: ['./plan-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanCardComponent implements OnInit, OnChanges {
  @Input() plan?: Plan;
  @Input() subscription: SubscriptionData;
  @Input() disabled = false;
  @Input() disabedTooltip?: string;
  @Output() selectPlan = new EventEmitter<PlanCardSelectEvent>();

  public isCurrentValidPlan = false;
  public isHostCard = false;
  public isProCard = false;
  public isMogulCard = false;
  public isLegacyCard = false;
  public features = [];
  public comingSoon = [];
  public subscribeWording: string;
  public currentlyMogul = false;

  constructor(
    private readonly upsellService: UpsellService,
    private readonly billingFacade: BillingFacade
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes): void {
    this.isHostCard = this.plan.plan_id === PlanId.Host;
    this.isProCard = this.plan.plan_id === PlanId.Professional;
    this.isLegacyCard = this.plan.plan_id === PlanId.Legacy;
    this.isMogulCard = this.plan.plan_id === PlanId.Mogul;
    this.isCurrentValidPlan = this.plan.current_plan && !isNotSubscribed(this.subscription);
    this.features = Object.values(PLANS_MAP[this.plan.plan_id]?.features);
    this.comingSoon = PLANS_MAP[this.plan.plan_id as PlanId.Mogul]?.comingSoon;
    this.currentlyMogul = this.subscription.plan.name === PlanId.Mogul;

    this.subscribeWording = this.buildSubscribeWording();
  }

  public contactSales() {
    this.upsellService.contactSalesForMogul('YourPlanPage');
  }

  private buildSubscribeWording() {
    const isSubscribed = !isNotSubscribed(this.subscription) || isPendingSubscription(this.subscription);
    const isLegacy = this.subscription.plan.name === PlanId.Legacy;

    if (isLegacy && this.isLegacyCard) {
      return 'Subscribe';
    }

    if (this.isMogulCard && !isSubscribed) {
      return 'Subscribe';
    }

    if (this.isMogulCard) {
      return 'Upgrade';
    }

    if (isSubscribed) {
      if (this.isHostCard) {
        return 'Downgrade';
      }

      if (isLegacy && this.isProCard) {
        return 'Upgrade';
      }

      if (!isLegacy && !this.currentlyMogul && this.isProCard) {
        return `Upgrade for ${this.plan.estimated_price?.formatted_string}/mo`;
      }
    }

    // Expired subscriptions (new and legacy), and trial subscriptions
    return `Subscribe for ${this.plan.estimated_price?.formatted_string}/mo`;
  }
}
